import { getConnections } from '@/redux/requests/connectionsRequests.js';
import deleteCompanyCredential from '@/redux/requests/credentials/deleteCompanyCredential.js';

/** Removes a connection; Pieve loses access to that account right away. */
const removeConnection = ({ connection }) => {
  return async () => {
    const removeRes = await deleteCompanyCredential({ credentialId: connection.credentialId, appId: connection.appId, source: 'pieve-web-connections' });

    if (removeRes?.success !== false) {
      await getConnections();
    }

    return removeRes;
  };
};

export default removeConnection;
